import InfiniteScroll from 'react-infinite-scroll-component'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'

import OrderOnline from '@entities/Order/ui/OrderOnline/OrderOnline'

import { PaymentVerifier } from '@features/payment/ui/payment-verifier/PaymentVerifier'

import { useInfiniteOrders } from '@widgets/order-online-list/model/useInfiniteOnlineOrders'



import styles from './styles.module.scss'

export default function OrderOnlineList () {
  const { items, hasMore, loadMore, refetch } = useInfiniteOrders()

  return (
    <InfiniteScroll
      className={styles.root}
      dataLength={items.length}
      next={loadMore}
      hasMore={hasMore}
      loader={
        <SkeletonTheme>
          <Skeleton
            count={3}
            width="100%"
            height={120}
            style={{ borderRadius: 16, marginBottom: 20 }}
          />
        </SkeletonTheme>
      }
    >
      {items.map((item, index) => (
        <OrderOnline
          key={`${item?.id}-${index}`}
          data={item}
          isInitialOpen={index === 0}
          onOrderUpdated={refetch}
        />
      ))}
      <PaymentVerifier isOrder onFinish={refetch} />
    </InfiniteScroll>
  )
}
